import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import intlShape from '@/shared/utils/intlShape';
import { AppointmentIcon, NoteIcon, PhoneIcon } from '@/shared/components/Icons';
import messages from '../registrationMessages';
import { actions } from '../registrationHelpers';
import RichTextEditor from '../../RichTextEditor';

const interactionTypes = [
  {
    id: 1,
    tooltip: messages.CreatePhoneCallTooltip,
    Icon: PhoneIcon,
  },
  {
    id: 0,
    tooltip: messages.CreateNoteTooltip,
    Icon: NoteIcon,
  },
  {
    id: 3,
    tooltip: messages.CreateMeetingReportTooltip,
    Icon: AppointmentIcon,
  },
];

const InteractionFormGroup = ({
  interactionType,
  interactionTitle,
  doAction,
  disabled,
  intl,
  initialInteractionDescription,
}) => (
  <div className="form-group">
    <div className="col-sm-3">
      <div className="btn-group btn-group-xs margin15B">
        {interactionTypes.map(({ id, tooltip, Icon }) => (
          <button
            key={id}
            onClick={() => {
              document.activeElement.blur();
              doAction(actions.interactionTypeChanged, id);
            }}
            disabled={disabled}
            type="button"
            title={intl.formatMessage(tooltip)}
            className={classnames('btn btn-xs btn-default', {
              active: interactionType === id,
            })}
          >
            <Icon className="react-icon" />
          </button>
        ))}
      </div>
    </div>
    <div className="col-sm-9">
      <input
        type="text"
        className="form-control input-sm margin10B"
        value={interactionTitle || ''}
        placeholder={intl.formatMessage(messages.CommunicationReportTitle)}
        disabled={disabled}
        onChange={e => doAction(actions.interactionTitleChanged, e.target.value)}
      />

      <RichTextEditor
        initialValue={initialInteractionDescription || ''}
        onChange={newContent => doAction(actions.interactionDescriptionChanged, newContent)}
        base64Images
        noToolbar
        id="NEW"
        readonly={disabled}
        placeholder={intl.formatMessage(messages.CommunicationReportDescription)}
      />
    </div>
  </div>
);
InteractionFormGroup.propTypes = {
  interactionType: PropTypes.oneOf([0, 1, 3, null]),
  interactionTitle: PropTypes.string,
  doAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  intl: intlShape.isRequired,
  initialInteractionDescription: PropTypes.string,
};

InteractionFormGroup.defaultProps = {
  interactionType: null,
  interactionTitle: null,
  disabled: false,
  initialInteractionDescription: '',
};
export default InteractionFormGroup;
